@if (!exportMode) {
  <div class="personal-data__edit-button-div">
    @if (editMode) {
      <button
        mat-raised-button
        class="personal-data__edit-btn personal-data__edit-btn--text"
        (click)="onCancelEdit()"
      >
        {{ 'general.cancel' | translate }}
      </button>

      <button
        mat-icon-button
        class="personal-data__edit-btn personal-data__edit-btn--icon"
        (click)="onCancelEdit()"
        [attr.aria-label]="'general.cancel' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <button
      mat-flat-button
      class="personal-data__edit-btn personal-data__edit-btn--text"
      [disabled]="saveDisabled"
      [matTooltip]="saveBlockedTooltip"
      (click)="onToggleEdit()"
    >
      {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
    </button>

    <button
      mat-icon-button
      class="personal-data__edit-btn personal-data__edit-btn--icon"
      [disabled]="saveDisabled"
      [matTooltip]="saveBlockedTooltip"
      (click)="onToggleEdit()"
      [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
    >
      <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
    </button>
  </div>
}

<mat-card class="personal-data__card">
  @if (!editMode && !exportMode && missingLevelCount > 0) {
    <p
      class="personal-data__missing-level-hint"
      [innerHTML]="
        (missingLevelCount === 1
          ? 'personalData.languageLevels.missingLevelHintOne'
          : 'personalData.languageLevels.missingLevelHintMany'
        ) | translate: { count: missingLevelCount }
      "
    ></p>
  }
  <form [formGroup]="personalForm">
    <div class="personal-data__content">
      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.position' | translate }}</mat-label>
          @if (personalData?.position) {
            <p class="personal-data__answer">{{ personalData.position }}</p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <mat-form-field>
            <mat-label class="personal-data__question">{{ 'personalData.position' | translate }}</mat-label>
            <input matInput type="text" formControlName="position" [maxlength]="LIMITS.SHORT_LABEL"
                   (keypress)="onKeyPress($event)"/>
            <mat-hint align="end">{{ (personalForm.get('position')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}
            </mat-hint>
            @if (personalForm.get("position")?.hasError('required')) {
              <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
            }
            @if (personalForm.get("position")?.hasError('maxlength')) {
              <mat-error>{{ 'general.validation.maxLength' | translate: {max: LIMITS.SHORT_LABEL} }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
      @if (canSeeEntryDate && !isApplicant) {
        <div class="personal-data__field">
          @if (!editMode) {
            <mat-label class="personal-data__question">{{ 'personalData.hireDate' | translate }}</mat-label>
            @if (personalData?.hireDate) {
              <p class="personal-data__answer">{{ personalData.hireDate | date: 'dd.MM.yyyy' }}</p>
            } @else {
              <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
            }
          } @else {
            <mat-form-field>
              <mat-label class="personal-data__question">{{ 'personalData.hireDate' | translate }}</mat-label>
              <input matInput [matDatepicker]="dpEntryDate" formControlName="eintrittsdatum" [readonly]="true"/>
              <mat-datepicker-toggle matIconSuffix [for]="dpEntryDate"></mat-datepicker-toggle>
              <mat-datepicker #dpEntryDate>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                  <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                </mat-datepicker-actions>
              </mat-datepicker>
              @if (personalForm.get('eintrittsdatum')?.invalid) {
                <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
              }
            </mat-form-field>
          }
        </div>
      }

      <div class="personal-data__field" [class.field-hint-anchor]="editMode">
        @if (!editMode) {
          <div class="personal-data__label-row">
            <mat-label class="personal-data__question">{{ 'personalData.consultantSince' | translate }}</mat-label>
            <app-field-hint [text]="'tooltip.beraterSeit' | translate" align="start"></app-field-hint>
          </div>
          @if (personalData?.beraterSeit) {
            <p class="personal-data__answer">{{ personalData.beraterSeit }}</p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <span class="field-hint-corner">
            <app-field-hint [text]="'tooltip.beraterSeit' | translate"></app-field-hint>
          </span>
          <div class="personal-data__field-row personal-data__field-row--top">
            <app-year-date-picker (changedYear)='setYear($event, "beraterSeit")'
                                  [date]='personalData.beraterSeit'
                                  [label]='"personalData.consultantSince"'></app-year-date-picker>
          </div>
        }
      </div>

      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.availableFrom' | translate }}</mat-label>
          @if (personalData?.verfuegbar) {
            <p class="personal-data__answer">{{ personalData.verfuegbar | date: "MM/yyyy" }}</p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <mat-form-field>
            <mat-label class="personal-data__question">{{ 'personalData.availableFrom' | translate }}
            </mat-label>
            <input matInput [matDatepicker]="datepicker" formControlName="verfuegbar" [readonly]="true"/>
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
              </mat-datepicker-actions>
            </mat-datepicker>
            @if (personalForm.get("verfuegbar")?.invalid) {
              <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
            }
          </mat-form-field>
        }
      </div>

      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.placeOfResidence' | translate }}</mat-label>
          @if (personalData?.wohnort) {
            <p class="personal-data__answer">{{ personalData.wohnort }}</p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <mat-form-field>
            <mat-label class="personal-data__question">{{ 'personalData.placeOfResidence' | translate }}
            </mat-label>
            <input matInput type="text" formControlName="wohnort" [maxlength]="LIMITS.LOCATION"
                   (keypress)="onKeyPress($event)"/>
            <mat-hint align="end">{{ (personalForm.get('wohnort')?.value?.length || 0) }}/{{ LIMITS.LOCATION }}
            </mat-hint>
            @if (personalForm.get("wohnort")?.hasError('required')) {
              <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
            }
            @if (personalForm.get("wohnort")?.hasError('maxlength')) {
              <mat-error>{{ 'general.validation.maxLength' | translate: {max: LIMITS.LOCATION} }}</mat-error>
            }
          </mat-form-field>
        }
      </div>

      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.nationality' | translate }}</mat-label>
          @if (personalData?.nationalitaet) {
            @if (isLegacyNationality(personalData.nationalitaet)) {
              <p class="personal-data__answer personal-data__answer--invalid">
                <app-field-warning [finding]="fieldFinding('nationalitaet')"></app-field-warning>
                <span>{{ personalData.nationalitaet | nationalityDisplayLabel: currentNationalityLang }}</span>
              </p>
              <small class="personal-data__field-hint personal-data__field-hint--warning">
                {{ 'personalData.error.legacyNationality' | translate }}
              </small>
            } @else {
              <p
                class="personal-data__answer">{{ personalData.nationalitaet | nationalityDisplayLabel: currentNationalityLang }}</p>
            }
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <app-ci-select
            class="personal-data__field-select"
            variant="filled"
            formControlName="nationalitaet"
            [items]="nationalityCodes"
            [displayWith]="displayNationality"
            [label]="'personalData.nationality' | translate"
            [placeholder]="'personalData.nationalityPlaceholder' | translate"
            [searchPlaceholder]="'personalData.nationalitySearch' | translate"
            [emptyLabel]="'personalData.nationalityEmpty' | translate"
            [hitTemplate]="'ciSelect.hits' | translate"
            [searchClearLabel]="'ciSelect.clearSearch' | translate"
            [ariaLabel]="'personalData.nationality' | translate"
            [invalid]="
              personalForm.get('nationalitaet')?.invalid &&
              personalForm.get('nationalitaet')?.touched
            "
            [errorText]="
              (personalForm.get('nationalitaet')?.errors?.['invalidOption']
                ? 'personalData.error.invalidNationality'
                : 'general.errors.required') | translate
            "
          ></app-ci-select>
        }
      </div>

      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.year' | translate }}</mat-label>
          @if (personalData?.jahrgang) {
            <p class="personal-data__answer">
              {{ personalData.jahrgang }}
              <app-field-warning [finding]="fieldFinding('jahrgang')"></app-field-warning>
            </p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <mat-form-field>
            <mat-label class="personal-data__question">{{ 'personalData.year' | translate }}</mat-label>
            <input matInput [matDatepicker]="jahrgangPicker" formControlName="jahrgang" [readonly]="true"/>
            <mat-datepicker-toggle matSuffix [for]="jahrgangPicker"></mat-datepicker-toggle>
            <mat-datepicker #jahrgangPicker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
              </mat-datepicker-actions>
            </mat-datepicker>
            @if (personalForm.get('jahrgang')?.invalid) {
              <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
            }
          </mat-form-field>
        }
      </div>

      <div class="personal-data__field">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.willingnessToTravel' | translate }}
          </mat-label>
          @if (personalData?.reisebereitschaft) {
            <p class="personal-data__answer">{{ personalData.reisebereitschaft | travelWillingness }}</p>
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <mat-form-field>
            <mat-label class="personal-data__question">{{ 'personalData.willingnessToTravel' | translate }}
            </mat-label>
            <mat-select formControlName="reisebereitschaft" id="rb" panelClass="ci-select-panel">
              @for (rB of rbOptions; track rB) {
                <mat-option [value]="rB.value">{{ rB.label | translate }}</mat-option>
              }
            </mat-select>
            @if (personalForm.get("reisebereitschaft")?.invalid) {
              <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
      @if (personalForm.get('reisebereitschaft')?.value === 'Eingeschränkt') {
        <div class="personal-data__restricted" [class.field-hint-anchor]="editMode">
          @if (!editMode) {
            <div class="personal-data__label-row">
              <mat-label class="personal-data__question">{{ 'personalData.limited' | translate }}</mat-label>
              <app-field-hint [text]="'tooltip.reisebereitschaftEingeschraenkt' | translate" align="start"></app-field-hint>
            </div>
            @if (personalData?.einschraenkung) {
              <p class="personal-data__answer">
                {{ personalData.einschraenkung }}
                <app-field-warning [finding]="fieldFinding('einschraenkung')"></app-field-warning>
              </p>
            } @else {
              <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
            }
          } @else {
            <span class="field-hint-corner">
              <app-field-hint [text]="'tooltip.reisebereitschaftEingeschraenkt' | translate"></app-field-hint>
            </span>
            <div class="personal-data__field-row personal-data__field-row--top">
              <mat-form-field>
                <mat-label class="personal-data__question">{{ 'personalData.limited' | translate }}</mat-label>
                <input matInput formControlName="einschraenkung" [maxlength]="LIMITS.FREETEXT"/>
                <mat-hint align="end">{{ (personalForm.get('einschraenkung')?.value?.length || 0) }}
                  /{{ LIMITS.FREETEXT }}
                </mat-hint>
              </mat-form-field>
            </div>
            @if (personalForm.get("einschraenkung")?.hasError('required')) {
              <div class="personal-data__field-error personal-data__field-error--restricted">
                <small>{{ 'personalData.error.limitedReasonRequired' | translate }}</small>
              </div>
            } @else if (personalForm.get("einschraenkung")?.hasError('minlength')) {
              <div class="personal-data__field-error personal-data__field-error--restricted">
                <small>{{ 'personalData.error.limitedReasonMinLength' | translate: {min: LIMITS.LIMITED_REASON_MIN} }}</small>
              </div>
            }
            @if (personalForm.get("einschraenkung")?.hasError('maxlength')) {
              <div class="personal-data__field-error personal-data__field-error--restricted">
                <small>{{ 'general.validation.maxLength' | translate: {max: LIMITS.FREETEXT} }}</small>
              </div>
            }
          }
        </div>
      }

      <div class="personal-data__row-break"></div>

      <div class="personal-data__field personal-data__text-entry">
        @if (!editMode) {
          <mat-label class="personal-data__question">{{ 'personalData.industries' | translate }}</mat-label>
          @if (personalData?.branchen?.length > 0) {
            @for (branche of personalData.branchen; track $index) {
              <div class="personal-data__export-row">
                @if (exportMode && twoPagerMode) {
                  <mat-checkbox
                    [checked]="selectedBranchen.includes(branche)"
                    [disabled]="!canSelectBranche(branche)"
                    (change)="toggleBrancheExport(branche, $event.checked)"
                    (click)="$event.stopPropagation()"
                    [attr.aria-label]="branche | vocabulary:'industry'"
                  ></mat-checkbox>
                }
                @if (isLegacyIndustry(branche)) {
                  <p class="personal-data__answer personal-data__answer--invalid">
                    <app-field-warning [finding]="valueFinding('branchen', branche)"></app-field-warning>
                    <span>{{ branche | vocabulary:'industry' }}</span>
                  </p>
                } @else {
                  <p class="personal-data__answer">{{ branche | vocabulary:'industry' }}</p>
                }
              </div>
            }
            @if (hasLegacyIndustries) {
              <small class="personal-data__field-hint personal-data__field-hint--warning">
                {{ 'personalData.error.legacyIndustry' | translate }}
              </small>
            }
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          @if (mainFocusesLimitExceeded || industriesLimitExceeded) {
            <div class="personal-data__badge-placeholder">
              @if (industriesLimitExceeded) {
                <lib-badge
                  [text]="'personalData.error.maxIndustries' | translate: { max: MAX_INDUSTRIES }"
                  [type]="'warning'">
                </lib-badge>
              }
            </div>
          }

          <app-industries-dropdown
            [availableIndustries]="(availableIndustries$ | async) ?? []"
            [selectedIndustries]="personalData.branchen ?? []"
            [required]="true"
            [invalid]="!!personalForm.get('branchen')?.errors?.['required']
              && (personalForm.get('branchen')?.touched || hasUnsavedChanges)"
            [errorText]="'personalData.error.industriesRequired' | translate"
            (industriesChange)="onIndustriesChange($event)">
          </app-industries-dropdown>
        }
      </div>
      <div class="personal-data__field personal-data__text-entry" [class.field-hint-anchor]="editMode">
        @if (!editMode) {
          <div class="personal-data__label-row">
            <mat-label class="personal-data__question">{{ 'personalData.mainFocus' | translate }}</mat-label>
            <app-field-hint [text]="'tooltip.schwerpunkte' | translate" align="start"></app-field-hint>
          </div>
          @if (personalData?.schwerpunkte?.length > 0) {
            @for (schwerpunkt of personalData.schwerpunkte; track schwerpunkt) {
              <div class="personal-data__export-row">
                @if (exportMode && twoPagerMode) {
                  <mat-checkbox
                    [checked]="selectedSchwerpunkte.includes(schwerpunkt)"
                    [disabled]="!canSelectSchwerpunkt(schwerpunkt)"
                    (change)="toggleSchwerpunktExport(schwerpunkt, $event.checked)"
                    (click)="$event.stopPropagation()"
                  ></mat-checkbox>
                }
                @if (isLegacyMainFocus(schwerpunkt)) {
                  <p class="personal-data__answer personal-data__answer--invalid">
                    <app-field-warning [finding]="valueFinding('schwerpunkte', schwerpunkt)"></app-field-warning>
                    <span>{{ schwerpunkt | vocabulary:'mainFocus' }}</span>
                  </p>
                } @else {
                  <p class="personal-data__answer">{{ schwerpunkt | vocabulary:'mainFocus' }}</p>
                }
              </div>
            }
            @if (hasLegacyMainFocuses) {
              <small class="personal-data__field-hint personal-data__field-hint--warning">
                {{ 'personalData.error.legacyMainFocus' | translate }}
              </small>
            }
          } @else {
            <p class="personal-data__missing">{{ 'personalData.unknown' | translate }}</p>
          }
        } @else {
          <span class="field-hint-corner">
            <app-field-hint [text]="'tooltip.schwerpunkte' | translate"></app-field-hint>
          </span>
          @if (mainFocusesLimitExceeded || industriesLimitExceeded) {
            <div class="personal-data__badge-placeholder">
              @if (mainFocusesLimitExceeded) {
                <lib-badge
                  [text]="'personalData.error.maxMainFocus' | translate: { max: MAX_MAINFOCUS }"
                  [type]="'warning'">
                </lib-badge>
              }
            </div>
          }

          <div class="personal-data__field-row personal-data__field-row--top">
            <app-main-focus-dropdown
              [availableMainFocuses]="(availableMainFocuses$ | async) ?? []"
              [selectedMainFocuses]="personalData.schwerpunkte ?? []"
              [required]="true"
              [invalid]="!!personalForm.get('schwerpunkte')?.errors?.['required']
                && (personalForm.get('schwerpunkte')?.touched || hasUnsavedChanges)"
              [errorText]="'personalData.error.mainFocusRequired' | translate"
              (mainFocusesChange)="onMainFocusChange($event)">
            </app-main-focus-dropdown>
          </div>
        }
      </div>
    </div>

    <div
      class="personal-data__languages"
      [attr.role]="editMode ? 'group' : null"
      [attr.aria-labelledby]="editMode ? 'personal-data-languages-title' : null"
    >
      <mat-divider></mat-divider>
      <div class="personal-data__languages-heading">
        @if (editMode) {
          <span id="personal-data-languages-title" class="personal-data__languages-title">
            <lib-subheadline
              [textColor]="'var(--primary-35)'"
              [subheadline]="'personalData.languageLevels.groupTitle'"
            ></lib-subheadline>
            <span class="personal-data__required-mark" aria-hidden="true">*</span>
          </span>
        } @else {
          <lib-subheadline [textColor]="'var(--primary-35)'" [subheadline]="'personalData.languages'"></lib-subheadline>
        }
        <app-field-hint [text]="'personalData.languageLevels.c2Info' | translate" align="start"></app-field-hint>
      </div>
      <app-language-levels
        formControlName="sprachen"
        [editMode]="editMode"
      ></app-language-levels>
    </div>

    <div class="personal-data__security">
      <mat-divider></mat-divider>
      <div class="personal-data__security-heading">
        <lib-subheadline [textColor]="'var(--primary-35)'" [subheadline]="'personalData.security.subheadline'"></lib-subheadline>
        <app-field-hint
          [text]="'tooltip.securityCheck' | translate"
          align="start"
          [wide]="true"
        ></app-field-hint>
      </div>
      @if (!editMode) {
        @if (personalData?.securityCheck?.length > 0) {
          <div class="personal-data__security-wrapper">
            <mat-label class="personal-data__question">
              {{ 'personalData.security.securityCheck' | translate }}
            </mat-label>
          </div>
        }
        @if (personalData?.securityCheck?.length > 0) {
          @for (securityCheck of personalData.securityCheck; track securityCheck; let i = $index) {
            <p class="personal-data__answer">
              {{ getSecurityLabel(securityCheck.typ) + ' -' }}
              <app-field-warning
                [finding]="entryFinding(i, 'securityCheckSubmittedOn')"
              ></app-field-warning>

              @if (securityCheck.submittedOn) {
                <span>{{ 'personalData.security.submitted' | translate }} {{ securityCheck.submittedOn | date: "dd.MM.yyyy" }}</span>
              }

              @if (securityCheck.completedOn) {
                <span>{{ 'personalData.security.completed' | translate }} {{ securityCheck.completedOn | date: "dd.MM.yyyy" }}</span>
              }

              @if (isSecurityCheckExpired(securityCheck.completedOn)) {
                <lib-badge
                  [text]="'personalData.security.expired' | translate"
                  [type]="'error'"
                ></lib-badge>
              } @else if (getRemainingMonths(securityCheck.completedOn) !== null) {
                <lib-badge
                  [text]="'personalData.security.validForMonths' | translate: {months: getRemainingMonths(securityCheck.completedOn)}"
                  [type]="'info'"
                ></lib-badge>
              }
            </p>
          }
        } @else {
          <p>{{ 'personalData.security.noData' | translate }}</p>
        }
      } @else {
        <mat-form-field class="personal-data__field-select-security">
          <mat-label>{{ 'personalData.security.securityCheck' | translate }}</mat-label>
          <mat-select
            [value]="selectedSecurityTypes"
            (selectionChange)="onSecurityChange($event.value)"
            multiple
            panelClass="ci-select-panel-multi"
          >
            @for (option of securityOptions; track option) {
              <mat-option [value]="option.code">
                {{ option.label | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (personalForm.get('securityCheck')?.value.length) {
          <div formArrayName="securityCheck" class="personal-data__selected-security">
            @for (scCtrl of personalForm.get('securityCheck')['controls']; track scCtrl; let i = $index) {
              <div [formGroupName]="i" class="personal-data__date-picker">
                <mat-label class="personal-data__question">{{ 'personalData.security.security' | translate }}
                  – {{ getSecurityLabel(scCtrl.get('typ')?.value) }}
                  :
                </mat-label>

                <div class="personal-data__date-picker-wrapper">
                  <mat-form-field>
                    <mat-label>{{ 'personalData.security.submittedDatePicker' | translate }}</mat-label>
                    <input matInput [matDatepicker]="submittedPicker" formControlName="submittedOn" required
                           [readonly]="true">
                    <mat-datepicker-toggle matSuffix [for]="submittedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #submittedPicker></mat-datepicker>
                    <mat-error>
                      {{ 'general.errors.required' | translate }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>{{ 'personalData.security.completedDatePicker' | translate }}</mat-label>
                    <input matInput [matDatepicker]="completedPicker" formControlName="completedOn" [readonly]="true">
                    <mat-datepicker-toggle matSuffix [for]="completedPicker"></mat-datepicker-toggle>
                    <mat-datepicker #completedPicker></mat-datepicker>
                  </mat-form-field>
                  @if (isSecurityCheckExpired(scCtrl.get('completedOn')?.value)) {
                    <div class="personal-data__badge-placeholder">
                      <lib-badge
                        [text]="'personalData.security.expired' | translate"
                        [type]="'error'"
                      ></lib-badge>
                    </div>
                  } @else if (getRemainingMonths(scCtrl.get('completedOn')?.value) !== null) {
                    <div class="personal-data__badge-placeholder">
                      <lib-badge
                        [text]="'personalData.security.validForMonths' | translate:{ months: getRemainingMonths(scCtrl.get('completedOn')?.value) }"
                        [type]="'info'"
                      ></lib-badge>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  </form>
</mat-card>
